import React, { Fragment } from 'react';

import PropTypes from 'prop-types';

import ErrorDetail from 'components/ErrorDetail';

import { format } from 'utils/tools';

const CLASS_NAME_FORM_CONTROL = 'form-control';
const CLASS_NAME_FORM_CONTROL_ERROR = 'form-control-error';

class Cep extends React.Component {
	static displayName = 'Cep';

	static propTypes = {
		formData: PropTypes.any,
		onChange: PropTypes.func,
		schema: PropTypes.object,
		errorSchema: PropTypes.object,
		readonly: PropTypes.bool,
		disabled: PropTypes.bool
	};

	constructor(props) {
		super(props);
		this.state = {
			cep: props.formData?.cep || '',
			valid: true
		};
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		return prevState;
	}

	onChangeText = e => {
		let { value } = e.target;
		let valid = false;
		if (value) {
			value = value.replace(/[^0-9]/g, '');
			value = value.substr(0, 8);

			if (value.length === 8) {
				value = format(value, '00.000-000');
				valid = true;
			}
		}
		this.setState(() => {
			this.props.onChange([{ cep: value, valid }]);
			return { cep: value, valid };
		});
	};

	render() {
		const requireds = this.props.schema.required || [];
		const requiredCep = requireds.indexOf('cep') > -1;
		const { cep: errorCep } = this.props.errorSchema;
		const { disabled, readonly } = this.props;
		return (
			<Fragment>
				{
					<Fragment>
						<div className="form-group col-md-12" style={{ whiteSpace: 'nowrap' }}>
							<label className="control-label hideable" htmlFor="root_nome">
								CEP
								{requiredCep ? '*' : ''}
							</label>
							<div />
							<input
								className={
									this.state.valid
										? `${CLASS_NAME_FORM_CONTROL}`
										: `${CLASS_NAME_FORM_CONTROL} ${CLASS_NAME_FORM_CONTROL_ERROR}`
								}
								type="text"
								placeholder="Informe o CEP"
								name="cep"
								value={this.state.cep}
								onChange={this.onChangeText}
								readOnly={readonly}
								disabled={disabled}
								maxLength={8}
							/>
							<ErrorDetail attr={errorCep} />
							<div />
						</div>
					</Fragment>
				}
			</Fragment>
		);
	}
}

export default Cep;
